/**
 *
 * Stepper
 *
 */

import React, { useContext } from 'react';
import _classNames from 'classnames';
import { makeStyles } from '@material-ui/core/styles';
import GuideMeContext from './GuideMeContext';

const useStyles = makeStyles({
  container: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    '& > div:first-child': {
      marginLeft: 0,
    },
    '& > div:last-child': {
      marginRight: 0,
    },
  },
  circle: {
    width: 11,
    height: 11,
    borderRadius: 5.5,
    marginLeft: 7,
    marginRight: 7,
  },
  inactive: {
    backgroundColor: '#A6A6A6',
  },
  previous: {
    backgroundColor: '#66C2B6',
  },
  current: {
    backgroundColor: '#01619B',
  },
});

const Stepper = () => {
  const classes = useStyles();
  const { currentStep, config } = useContext(GuideMeContext);

  return (
    <div className={classes.container}>
      {Array.from(new Array(config.steps.length)).map((_, index) => (
        <div
          key={`guide-me-stepper-${index}`}
          className={_classNames({
            [classes.circle]: true,
            [classes.inactive]: index > currentStep,
            [classes.previous]: index < currentStep,
            [classes.current]: index === currentStep,
          })}
        />
      ))}
    </div>
  );
};

export default Stepper;
